<div class="sidebar_container">
  <div class="header">
    <!-- Go Back Action -->
    <button type="button" class="header-back" (click)="goBack()" [attr.aria-label]="'Back'">
      <ui-icon name="ArrowLeft"></ui-icon>
    </button>
    <div class="header-title">
      {{"settings.settings" | translate}}
    </div>
  </div>

  <div class="list_modules">
    <ui-nav-section
      [label]="'settings.user_settings' | translate"
      [collapsed]="!!toggleUserSettings"
      (toggled)="toggle('userSettings')">
    </ui-nav-section>
    <div class="module_container" *ngIf="!toggleUserSettings">
      <a ui-nav-item class="module"
        routerLink="/settings/profile"
        routerLinkActive="active"
      >
        <ui-icon name="User"></ui-icon>
        <span class="title">{{"user.user" | translate}}</span>
      </a>
      <!-- Ungated: a per-user setting, like the profile above. -->
      <a ui-nav-item class="module"
        routerLink="/settings/security"
        routerLinkActive="active"
      >
        <ui-icon name="ShieldCheck"></ui-icon>
        <span class="title">{{"settings.security" | translate}}</span>
      </a>
      <a ui-nav-item class="module"
        routerLink="/settings/tips"
        routerLinkActive="active"
      >
        <ui-icon name="Lightbulb"></ui-icon>
        <span class="title">{{"ftue.settings.nav_label" | translate}}</span>
      </a>
    </div>

    <ng-container *appHasPermission="{ module: 'settings_team' }">
      <ui-nav-section
        [label]="'settings.team_management' | translate"
        [collapsed]="!!toggleTeamManagement"
        (toggled)="toggle('teamManagement')">
      </ui-nav-section>
      <div class="module_container" *ngIf="!toggleTeamManagement">
        <a ui-nav-item class="module" routerLink="/settings/users"
          routerLinkActive="active"
        >
          <ui-icon name="Users"></ui-icon>
          <span class="title">{{"settings.users" | translate}}</span>
        </a>
        <a ui-nav-item class="module" routerLink="/settings/teams"
          routerLinkActive="active"
        >
          <ui-icon name="UsersRound"></ui-icon>
          <span class="title">{{"settings.teams" | translate}}</span>
        </a>
        <a ui-nav-item class="module" routerLink="/settings/roles"
          routerLinkActive="active"
        >
          <ui-icon name="Shield"></ui-icon>
          <span class="title">{{"settings.roles_permissions" | translate}}</span>
        </a>
      </div>
    </ng-container>

    <ng-container *appHasPermission="{ module: 'settings_company' }">
      <ui-nav-section
        [label]="'settings.company_settings' | translate"
        [collapsed]="!!toggleCompanySettings"
        (toggled)="toggle('companySettings')">
      </ui-nav-section>
      <div class="module_container" *ngIf="!toggleCompanySettings">
        <!-- <a ui-nav-item class="module" routerLink="/settings/language"
          routerLinkActive="active"
        >
          <ui-icon name="Globe"></ui-icon>
          <span class="title">{{"settings.language" | translate}}</span>
        </a> -->
        <a ui-nav-item class="module" routerLink="/settings/notifications"
          routerLinkActive="active"
          *appHasPermission="{ module: 'settings_company' }"
        >
          <ui-icon name="Bell"></ui-icon>
          <span class="title">{{"settings.notifications" | translate}}</span>
        </a>
        <a ui-nav-item class="module" routerLink="/settings/warehouses"
          routerLinkActive="active"
          *appHasPermission="{ module: 'settings_company' }"
        >
          <ui-icon name="Package"></ui-icon>
          <span class="title">{{"settings.warehouses" | translate}}</span>
        </a>
        <a ui-nav-item class="module" routerLink="/settings/custom-fields"
          routerLinkActive="active"
          *appHasPermission="{ module: 'settings_company' }"
        >
          <ui-icon name="Code"></ui-icon>
          <span class="title">{{"settings.custom_fields" | translate}}</span>
        </a>
        <a ui-nav-item class="module" routerLink="/settings/smart-inbox"
          routerLinkActive="active"
          *appHasPermission="{ module: 'smart_inbox' }"
        >
          <ui-icon name="Mail"></ui-icon>
          <span class="title">{{"settings.smart_inbox" | translate}}</span>
        </a>
        <a ui-nav-item class="module" routerLink="/settings/orders"
          routerLinkActive="active"
          *appHasPermission="{ module: 'settings_company' }"
        >
          <ui-icon name="ShoppingBag"></ui-icon>
          <span class="title">{{"settings.orders" | translate}}</span>
        </a>
      </div>
    </ng-container>
  </div>

  <!-- Signed-in user + icon-only logout, identical to the main sidebar. -->
  <ui-sidebar-footer (logout)="logout()"></ui-sidebar-footer>
</div>
